import { useTranslations } from 'next-intl'

import { PageNotFound } from '@/shared/asset'
import { Link } from '@/shared/i18n'
import { Button } from '@/shared/ui'
import { NavigationBar } from '@/widgets/navigation-bar'

export const NotFoundPage = () => {
  const t = useTranslations('common.error')

  return (
    <>
      <NavigationBar />
      <div className="flex h-[calc(100vh-72px)] flex-col items-center bg-gray-50 pt-30">
        <PageNotFound className="mb-6 block" />
        <h2 className="typo-headline2 mb-4 font-bold text-black">
          {t('not_found.title')}
        </h2>
        <p className="typo-body1 mb-10 text-center font-normal whitespace-break-spaces text-gray-900">
          {t('not_found.description')}
        </p>
        <Button
          asChild
          variant="solid"
          color="primary"
          size="large"
          className="w-60"
        >
          <Link href="/">{t('button.home')}</Link>
        </Button>
      </div>
    </>
  )
}
